import React from 'react'
import {useTranslation} from 'next-i18next'

import useReferralProgramConfig from './useReferralProgramConfig.main'

export default function NotReady() {
  const {loyaltyProgramConfig} = useReferralProgramConfig()
  const {t} = useTranslation('website', {keyPrefix: 'referralProgram.notReady'})
  return (
    <div className="flex justify-center">
      <div className="flex max-w-lg flex-col gap-4 rounded-lg bg-gradient-to-br from-slate-700 via-slate-500 to-slate-600 p-4 text-white drop-shadow-md">
        <h3 className="font-semibold text-base text-center">{t('title')}</h3>
        <p>
          {t('message', {
            pointsToGive: loyaltyProgramConfig?.referralProgramConfig?.fixedAccumulationAmount,
            pointsName: loyaltyProgramConfig?.name
          })}
        </p>
      </div>
    </div>
  )
}
